export default (values) => {

  const errors = {};

  if (!values.first_name) errors.first_name = true;

  return errors;
  
}